export const PERMISSIONS_TREE = [
  {
    category: 'Admin',
    permissions: [
      {
        id: 'admin:access',
        label: 'Admin Access',
        description: 'Access the admin control panel.',
      },
      {
        id: 'admin:users:view',
        label: 'View Users',
        description: 'View the list of users in the system.',
      },
      {
        id: 'admin:users:manage',
        label: 'Manage Users',
        description: 'Create, update, or delete users.',
      },
      {
        id: 'admin:users:export',
        label: 'Export Users',
        description: 'Export user data to a file.',
      },
      {
        id: 'admin:tokens:view',
        label: 'View Token Usage',
        description: 'View token and cost usage across the system.',
      },
      {
        id: 'admin:mcp:view',
        label: 'View MCP Connections',
        description: 'View system-wide MCP origin connections.',
      },
      {
        id: 'admin:mcp:manage',
        label: 'Manage MCP Connections',
        description: 'Add, edit, or remove MCP origin connections.',
      },
      {
        id: 'admin:config:view',
        label: 'View Configuration',
        description:
          'See application-wide prompts, rubrics, scoring and settings.',
      },
      {
        id: 'admin:config:manage',
        label: 'Manage Configuration',
        description:
          'Edit and publish application-wide prompts, rubrics and settings. Applies to every project.',
      },
    ],
  },
  {
    category: 'Project',
    permissions: [
      {
        id: 'project:create',
        label: 'Create Project',
        description: 'Create a new project or workspace.',
      },
      {
        id: 'project:view',
        label: 'View Project',
        description: 'View project details.',
      },
      {
        id: 'project:delete',
        label: 'Delete Project',
        description: 'Delete an existing project.',
      },
    ],
  },
  {
    category: 'User Profile',
    permissions: [
      {
        id: 'user:logout',
        label: 'Logout',
        description: 'Sign out of the application.',
      },
      {
        id: 'user:profile:view',
        label: 'View Profile',
        description: 'View your own user profile.',
      },
    ],
  },
  {
    category: 'User Management (Team)',
    permissions: [
      {
        id: 'user_management:view',
        label: 'View Team Members',
        description: 'View members within a project or organization.',
      },
      {
        id: 'user_management:create',
        label: 'Invite/Create Team Members',
        description: 'Add new members to the team.',
      },
      {
        id: 'user_management:update',
        label: 'Update Team Members',
        description: 'Modify team member details.',
      },
      {
        id: 'user_management:delete',
        label: 'Remove Team Members',
        description: 'Remove members from the team.',
      },
    ],
  },
  {
    category: 'Access Control (Roles & Permissions)',
    permissions: [
      {
        id: 'access_control:role:create',
        label: 'Create Role',
        description: 'Define new custom roles.',
      },
      {
        id: 'access_control:role:view',
        label: 'View Roles',
        description: 'View existing roles in the system/project.',
      },
      {
        id: 'access_control:role:update',
        label: 'Edit Role',
        description: "Modify an existing role's permissions.",
      },
      {
        id: 'access_control:role:delete',
        label: 'Delete Role',
        description: 'Delete an existing role.',
      },
      {
        id: 'access_control:role:assign',
        label: 'Assign Roles',
        description: 'Assign a role to a user.',
      },
      {
        id: 'access_control:role:revoke',
        label: 'Revoke Roles',
        description: 'Remove a role from a user.',
      },
      {
        id: 'access_control:permission:view_own',
        label: 'View Own Permissions',
        description: 'View the permissions assigned to yourself.',
      },
    ],
  },
  {
    category: 'Task Management',
    permissions: [
      {
        id: 'task:create',
        label: 'Create Tasks',
        description: 'Create new tasks or tickets.',
      },
      {
        id: 'task:view',
        label: 'View Tasks',
        description: 'View existing tasks.',
      },
      {
        id: 'task:update',
        label: 'Update Tasks',
        description: 'Edit existing tasks.',
      },
      {
        id: 'task:delete',
        label: 'Delete Tasks',
        description: 'Delete tasks.',
      },
    ],
  },
  {
    category: 'Chat & AI Engine',
    permissions: [
      {
        id: 'chat:send',
        label: 'Send Messages',
        description: 'Send chat messages to the AI.',
      },
      {
        id: 'chat:approve',
        label: 'Approve Tool Execution',
        description: 'Approve or deny tools executed by the AI.',
      },
      {
        id: 'chat:web:view',
        label: 'View Web Chat',
        description: 'Access the standalone chat interface.',
      },
      {
        id: 'chat:web:manage',
        label: 'Manage Web Chat',
        description: 'Manage chat settings and history.',
      },
      {
        id: 'chat:llm:use',
        label: 'Direct AI Use',
        description: 'Direct API access to language models.',
      },
    ],
  },
  {
    category: 'Data Sources & Files',
    permissions: [
      {
        id: 'datasource:view',
        label: 'View Data Sources',
        description: 'View attached data sources for context.',
      },
      {
        id: 'datasource:manage',
        label: 'Manage Data Sources',
        description: 'Add, sync, or remove data sources.',
      },
      {
        id: 'file:view',
        label: 'View Files',
        description: 'View uploaded files.',
      },
      {
        id: 'file:manage',
        label: 'Manage Files',
        description: 'Upload or delete files.',
      },
      {
        id: 'image:view',
        label: 'View Images',
        description: 'View uploaded images.',
      },
      {
        id: 'image:manage',
        label: 'Manage Images',
        description: 'Upload or delete images.',
      },
      {
        id: 'template:view',
        label: 'View Document Templates',
        description: 'View existing document templates.',
      },
      {
        id: 'template:manage',
        label: 'Manage Document Templates',
        description: 'Create, edit, or delete document templates.',
      },
      {
        id: 'dashboard:view',
        label: 'View Dashboards',
        description: 'Open your dashboards.',
      },
      {
        id: 'dashboard:manage',
        label: 'Manage Dashboards',
        description: 'Create, edit, or delete your dashboards.',
      },
      {
        id: 'dashboard:share',
        label: 'Share Dashboards',
        description: 'Share dashboards with teammates or by a public link.',
      },
      {
        id: 'parser:view',
        label: 'View Parsers',
        description: 'View document parser setups.',
      },
      {
        id: 'parser:manage',
        label: 'Manage Parsers',
        description: 'Configure document parsers.',
      },
    ],
  },
  {
    category: 'Integrations & Extensions',
    permissions: [
      {
        id: 'integration:view',
        label: 'View Integrations',
        description: 'View connected third-party integrations.',
      },
      {
        id: 'integration:connect',
        label: 'Connect Integrations',
        description: 'Link a new third-party integration.',
      },
      {
        id: 'integration:disconnect',
        label: 'Disconnect Integrations',
        description: 'Unlink an integration.',
      },
      {
        id: 'integration:resources:view',
        label: 'View Integration Resources',
        description: 'View resources from connected apps.',
      },
      {
        id: 'integration:resources:manage',
        label: 'Manage Integration Resources',
        description: 'Manage resources synced from connected apps.',
      },
      {
        id: 'mcp:view',
        label: 'View Project MCPs',
        description: 'View MCP connections at the project level.',
      },
      {
        id: 'mcp:manage',
        label: 'Manage Project MCPs',
        description: 'Configure MCP connections for the project.',
      },
      {
        id: 'mcp:execute',
        label: 'Execute MCP APIs',
        description: 'Use MCP connected API endpoints.',
      },
      {
        id: 'webhook:view',
        label: 'View Webhooks',
        description: 'View outgoing webhook configurations.',
      },
      {
        id: 'webhook:manage',
        label: 'Manage Webhooks',
        description: 'Create or modify outgoing webhooks.',
      },
    ],
  },
  {
    category: 'Automation (Bots & Canvas)',
    permissions: [
      {
        id: 'bot:view',
        label: 'View Bots',
        description: 'View configured AI agents/bots.',
      },
      {
        id: 'bot:create',
        label: 'Create Bots',
        description: 'Create new AI agents.',
      },
      {
        id: 'bot:update',
        label: 'Edit Bots',
        description: 'Modify existing AI agents.',
      },
      {
        id: 'bot:delete',
        label: 'Delete Bots',
        description: 'Remove AI agents.',
      },
      {
        id: 'bot:execute',
        label: 'Run Bots',
        description: 'Trigger bot execution.',
      },
      {
        id: 'bot:steps:view',
        label: 'View Bot Steps',
        description: "View a bot's internal steps.",
      },
      {
        id: 'bot:steps:manage',
        label: 'Manage Bot Steps',
        description: "Edit a bot's internal steps.",
      },
      {
        id: 'bot:session:view',
        label: 'View Bot Sessions',
        description: 'View history of bot execution sessions.',
      },
      {
        id: 'bot:session:manage',
        label: 'Manage Bot Sessions',
        description: 'Control or clear bot sessions.',
      },
      {
        id: 'workflow:view',
        label: 'View Canvas Workflows',
        description: 'View canvas-based visual workflows.',
      },
      {
        id: 'workflow:create',
        label: 'Create Canvas Workflows',
        description: 'Build new canvas workflows.',
      },
      {
        id: 'workflow:update',
        label: 'Edit Canvas Workflows',
        description: 'Modify existing canvas workflows.',
      },
      {
        id: 'workflow:execute',
        label: 'Run Canvas Workflows',
        description: 'Trigger execution of a canvas workflow.',
      },
      {
        id: 'agent:view',
        label: 'View Agent Configs',
        description: 'View backend agent configurations.',
      },
      {
        id: 'agent:update',
        label: 'Manage Agent Configs',
        description: 'Update backend agent configurations.',
      },
    ],
  },
  {
    category: 'Email & Communication',
    permissions: [
      {
        id: 'email:view',
        label: 'View All Emails',
        description: 'View emails from connected accounts.',
      },
      {
        id: 'email_actions:view',
        label: 'View Email Actions',
        description: 'View pending email workflows (e.g. draft replies).',
      },
      {
        id: 'email_actions:manage',
        label: 'Manage Email Actions',
        description: 'Delete or edit pending email workflows.',
      },
      {
        id: 'email_actions:approve',
        label: 'Approve Email Actions',
        description: 'Approve AI-generated email actions to be sent.',
      },
      {
        id: 'mail_intel:mailbox:connect',
        label: 'Connect Mailbox (Mail Intelligence)',
        description:
          'Connect own mailbox for project mail triage and answer the weekly gate audit.',
      },
      {
        id: 'mail_intel:inbox:view',
        label: 'View Mail Triage',
        description:
          'See the project mail triage tab, thread panels and summaries (ranked for own delivery role).',
      },
      {
        id: 'mail_intel:decision_map:manage',
        label: 'Manage Decision Owners',
        description:
          'Choose which delivery role owns each kind of decision on a project.',
      },
      {
        id: 'gmail:view',
        label: 'View Gmail',
        description: 'View emails using Gmail API.',
      },
      {
        id: 'gmail:send',
        label: 'Send via Gmail',
        description: 'Send emails using Gmail API.',
      },
      {
        id: 'gmail:manage',
        label: 'Manage Gmail Config',
        description: 'Change Gmail integration settings.',
      },
      {
        id: 'outlook:view',
        label: 'View Outlook',
        description: 'View emails using Outlook API.',
      },
      {
        id: 'outlook:send',
        label: 'Send via Outlook',
        description: 'Send emails using Outlook API.',
      },
      {
        id: 'outlook:manage',
        label: 'Manage Outlook Config',
        description: 'Change Outlook integration settings.',
      },
      {
        id: 'work_email:view',
        label: 'View Work Email',
        description: 'View unified work email feeds.',
      },
      {
        id: 'work_email:manage',
        label: 'Manage Work Email',
        description: 'Configure unified work email settings.',
      },
    ],
  },
  {
    category: 'System Actions',
    permissions: [
      {
        id: 'system_prompt:view',
        label: 'View System Prompts',
        description: "View the AI's core instructions.",
      },
      {
        id: 'system_prompt:manage',
        label: 'Manage System Prompts',
        description: "Edit the AI's core instructions.",
      },
      {
        id: 'search:use',
        label: 'Cross-platform Search',
        description: 'Use the global cross-integration search.',
      },
      {
        id: 'feedback:submit',
        label: 'Submit Feedback',
        description: 'Submit feedback or issue reports.',
      },
    ],
  },
  {
    category: 'App Specific',
    permissions: [
      {
        id: 'jira:view',
        label: 'View Jira',
        description: 'View Jira boards and issues.',
      },
      {
        id: 'jira:manage',
        label: 'Manage Jira Setup',
        description: 'Configure Jira integration.',
      },
      {
        id: 'jira:issue:update',
        label: 'Update Jira Issues',
        description: 'Edit tickets in Jira.',
      },
      {
        id: 'jira:issue:comment',
        label: 'Comment on Jira',
        description: 'Add comments to Jira tickets.',
      },
      {
        id: 'jira:sprint:view',
        label: 'View Jira Sprints',
        description: 'View sprint details in Jira.',
      },
      {
        id: 'jira:sprint:manage',
        label: 'Manage Jira Sprints',
        description: 'Start or edit Jira sprints.',
      },
      {
        id: 'linear:view',
        label: 'View Linear',
        description: 'View Linear issues.',
      },
      {
        id: 'linear:manage',
        label: 'Manage Linear Setup',
        description: 'Configure Linear integration.',
      },
      {
        id: 'confluence:view',
        label: 'View Confluence',
        description: 'View Confluence pages.',
      },
      {
        id: 'confluence:manage',
        label: 'Manage Confluence Setup',
        description: 'Configure Confluence integration.',
      },
      {
        id: 'github:view',
        label: 'View GitHub',
        description: 'View GitHub repositories and PRs.',
      },
      {
        id: 'github:manage',
        label: 'Manage GitHub Setup',
        description: 'Configure GitHub webhooks/integration.',
      },
      {
        id: 'quickbooks:view',
        label: 'View QuickBooks Data',
        description: 'View invoices and financial data.',
      },
      {
        id: 'meeting:view',
        label: 'View Meetings',
        description: 'View calendar events and recorded meetings.',
      },
      {
        id: 'meeting:manage',
        label: 'Manage Meetings',
        description: 'Schedule or update meeting events.',
      },
      {
        id: 'notification:view',
        label: 'View Notifications',
        description: 'View application alerts.',
      },
      {
        id: 'notification:manage',
        label: 'Manage Notifications',
        description: 'Mark notifications read/unread or clear them.',
      },
    ],
  },
];

export const getPermissionLabel = (id) => {
  for (const cat of PERMISSIONS_TREE) {
    const perm = cat.permissions.find((p) => p.id === id);
    if (perm) return perm.label;
  }
  return id;
};
